// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RichUtils } from "draft-js";
import { Tooltip } from "../../revvComponents";

// Internal Imports
import { DRAFT } from "../../constants";

// Destructing
const { TOOLBAR_HYPERLINK_BUTTON } = DRAFT;

class HyperlinkButton extends Component {
  _onToggle = event => {
    event.preventDefault();
    // Add the "editorState" and "component" to CustomRevvToolbar, so that
    // these data can be use for adding the hyperlink because,
    // the origin data will be lost because of onBlur
    this.props.preventEditorToDeactivate(false);
    this.props.showHyperlinkBox(
      this.props.editorState,
      this.props.component,
      this.props.activeComponentMeta,
    );
  };

  render() {
    const { editorState } = this.props;
    const isURLPresent = RichUtils.currentBlockContainsLink(editorState);
    return TOOLBAR_HYPERLINK_BUTTON.map(btn => {
      const className = "draftJsToolbar__button__qi1gf normal-text-button";
      return (
        <div
          className="draft_edit_items"
          id={btn.toolbarID}
          key={btn.toolbarID}>
          <div className="draftJsToolbar__buttonWrapper__1Dmqh" key={btn.id}>
            <Tooltip
              placement="top"
              overlay={
                isURLPresent ? btn.modifyLinkTooltip : btn.addLinkTooltip
              }
              align={{
                offset: [3, 0],
              }}>
              <button
                type="button"
                className={className}
                onMouseDown={event => this._onToggle(event)}
                data-test="hyperlink-btn">
                <FontAwesomeIcon
                  icon={["fas", `${btn.icon}`]}
                  className="ic-hyperlink"
                />
              </button>
            </Tooltip>
          </div>
        </div>
      );
    });
  }
}

export default HyperlinkButton;
